@if (true) {
  <router-outlet></router-outlet>
}
<app-toast-container />
